import React, { useEffect, useState } from "react";
import OffCanvasModal from "../../components/OffCanvasModal";
import LoaderImage from "../../images/ohhto-loading.gif";
import ImageInput from "../../components/ImageInput";
import CropPopup from "../../components/CropPopup";
import ConfirmationPopup from "../../components/ConfirmationPopup";
import SearchInput from "../../components/SearchInput";
import CountryCode from "../../config/countryCode.json";
import Input from "../../components/Input";
import AgentGridItem from "./components/AgentGridItem";
import { useDispatch, useSelector } from "react-redux";
import axios from "../../helpers/axios";
import {
  dataURItoBlob,
  getCountryFromSettings,
  getNameFromSettings,
} from "../../helpers/utils";
import {
  DuplicateCheck,
  IMAGE_BASE_URL,
  SETTINGS_APPROVAL_TIME_LIST,
  SETTINGS_LTV_LIST,
  SORT_KEY_RECENT,
  SORT_ORDER_DESC,
} from "../../helpers/constants";
import PrimaryHeader from "../../components/PrimaryHeader";
import CustomSelect from "../../components/CustomSelect";
import { Link, useLocation } from "react-router-dom";
import AgentConfirmationPopup from "../../components/AgentConfirmationPopup";
import { setagentAccountFilter } from "../../redux/slice/agentAccountSlice";
import { toast } from "react-toastify";
import LoaderComp from "../../components/LoaderComp";
import InfoTab from "./components/InfoTab";
import { SecurityPinNumber } from "./components/SecurityPinNumber";

export default function Agents() {
  const location = useLocation();
  const pagePermission = location.state;
  //console.log("pagePermission", pagePermission);
  const dispatch = useDispatch();
  const agentAccountsFilter = useSelector(
    (state) => state?.agentAccountFilter?.agentAccountFilter
  );
  const [anchorEls, setAnchorEls] = useState([]);
  const [activeTab, setActiveTab] = useState(
    Object.keys(agentAccountsFilter)?.length > 0
      ? agentAccountsFilter
      : {
        parameter: "status",
        value: 0,
      }
  );

  const [menuOpen, setMenuOpen] = useState(false);
  const [showManageModal, setShowManageModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  // const [showFeatureModal,setShowFeatureModal] = useState(false)
  const [featureModal, setFeatureModal] = useState({
    show: false,
    id: null,
    status: null,
  });
  const [inactiveModal, setInactiveModal] = useState({
    show: false,
    id: null,
    status: null,
  });
  const [deleteModal, setDeleteModal] = useState({
    show: false,
    id: null,
    status: null,
  });
  const [tabData, setTabData] = useState([
    { label: "Pending", count: null, value: 0 },
    { label: "Approved", count: null, value: 1 },
    { label: "Rejected", count: null, value: 2 },
  ]);
  const authInfo = useSelector((state) => state.auth);
  const [searchText, setSearchText] = useState("");
  const [sort, setSort] = useState({
    sortKey: SORT_KEY_RECENT,
    sortOrder: SORT_ORDER_DESC,
  });
  const [loading, setLoading] = useState(false);

  const [tabFilterData, setTabFilterData] = useState([]);
  const [items, setItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalData, setTotalData] = useState(0);

  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [agentId, setAgentId] = useState(null);

  async function getAgents() {
    let res = await axios.post(
      `/admin/agent/list/24/${currentPage}`,
      {
        keyword: searchText,
        sortKey: sort.sortKey,
        sortOrder: sort.sortOrder,
        keyword: searchText,
        [`${activeTab.parameter}`]: activeTab.value,
      }
    );
    setItems(
      items?.length > 0
        ? DuplicateCheck(items?.concat(res.data.data))
        : res.data.data
    );
    setTabData(res.data.counts);
    setTabFilterData(
      tabFilterData?.length > 0
        ? DuplicateCheck(tabFilterData?.concat(res.data.data))
        : res.data.data
    );
    setTotalData(res.data?.total);
  }

  const handleScroll = () => {
    if (
      Math.round(window.innerHeight) +
      Math.round(document.documentElement.scrollTop) !==
      Math.round(document.documentElement.offsetHeight)
    ) {
      if (
        document.documentElement.offsetHeight -
        (window.innerHeight +
          Math.round(document.documentElement.scrollTop)) <=
        1
      ) {
        //console.log("CHECKKING", tabFilterData, totalData);
        if (tabFilterData?.length < totalData && !loading) {
          setCurrentPage(currentPage + 1);
          getAgents(currentPage + 1, "scroll");
        }
      } else {
        return;
      }
    } else {
      //console.log("CHECKKING", tabFilterData, totalData);

      if (tabFilterData?.length < totalData && !loading) {
        setCurrentPage(currentPage + 1);
        getAgents(currentPage + 1, "scroll");
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [loading]);

  useEffect(() => {
    async function getAgents() {
      setLoading(true);
      let res = await axios.post(
        `/admin/agent/list/24/1`,
        {
          keyword: searchText,
          sortKey: sort.sortKey,
          sortOrder: sort.sortOrder,
          keyword: searchText,
          [`${activeTab.parameter}`]: activeTab.value,
        }
      );
      setItems(res.data.data);
      setTabData(res.data.counts);
      setTabFilterData(res.data.data);
      setTotalData(res.data?.total);

      setLoading(false);
    }
    getAgents();
  }, [activeTab, sort]);
  useEffect(() => {
    setAnchorEls(Array(tabFilterData?.length).fill(null));
  }, [tabFilterData]);
  // useEffect(() => {
  //   async function getAgents() {
  //     setLoading(true);
  //     let res = await axios.post(
  //       `/admin/agent/list/24/1`,
  //       {
  //         keyword: searchText,
  //         sortKey: sort.sortKey,
  //         sortOrder: sort.sortOrder,
  //         keyword: searchText,
  //         [`${activeTab.parameter}`]: activeTab.value,
  //       }
  //     );
  //     setItems(res.data.data);
  //     setTabData(res.data.counts);
  //     setTabFilterData(res.data.data);
  //     setTotalData(res.data?.total);

  //     setLoading(false);
  //   }
  //   if (searchText && searchText.length > 1) getAgents();
  //   else if (searchText === "") getAgents();
  // }, [searchText]);

  const onChange = (data) => {
    dispatch(setagentAccountFilter(data));
  };

  const confirmFeatured = async (id, status) => {
    try {
      let itemData = tabFilterData.find((item) => item.id === id);
      let res = await axios.put(`/admin/agent/update/${id}`, {
        ...itemData,
        featured: !status,
      });
      if (res.status < 400) {
        await getAgents();
        toast.success(res.data?.message);
        setFeatureModal((data) => ({
          ...data,
          id: null,
          status: null,
          show: false,
        }));
      } else throw { response: "Invalid response" };
    } catch (error) {
      Object.keys(error.response.data.errors).forEach(function (key) {
        toast.error(
          error.response.data.errors[key] !== undefined
            ? error.response.data.errors[key]
            : "Error occured profile not updated..!"
        );
      });
    }
  };

  const confirmInactive = async (id, status) => {
    let updatedList = items.map((item) => {
      if (item.id == id) {
        return { ...item, inactive: !status }; //gets everything that was already in item, and updates "done"
      }
      return item; // else return unmodified item
    });
    //console.log(updatedList);
    setItems(updatedList);
    setInactiveModal((data) => ({
      ...data,
      show: false,
      id: null,
      status: false,
    }));
  };

  const confirmDelete = async (id) => {
    try {
      let res = await axios.delete(`/admin/agent/delete/${id}`);
      if (res.status < 400) {
        await getAgents();
        setDeleteModal(false);
      } else throw { response: "Invalid response" };
    } catch (error) {
      Object.keys(error.response.data.errors).forEach(function (key) {
        toast.error(
          error.response.data.errors[key] !== undefined
            ? error.response.data.errors[key]
            : "Error occured profile not updated..!"
        );
      });
      //console.log(error);
    }
  };

  const handleOpenMenu = (index, event) => {
    const newAnchorEls = [...anchorEls];
    newAnchorEls[index] = event.currentTarget;
    setAnchorEls(newAnchorEls);
    setMenuOpen(true);
  };

  const handleCloseMenu = () => {
    setAnchorEls(Array(tabFilterData.length).fill(null));
    setMenuOpen(false);
  };

  const onFeatureClick = async (id, status) => {
    setFeatureModal((data) => ({
      ...data,
      id: id,
      status: status,
      show: true,
    }));
  };
  const onInactiveClick = async (id, status) => {
    setInactiveModal((data) => ({
      ...data,
      id: id,
      status: status,
      show: true,
    }));
  };
  const onDeleteClick = async (id) => {
    setDeleteModal((data) => ({ ...data, id: id, show: true }));
  };
  // const onEditClick = async(data)=>
  // {
  //    setShowUpdateModal((data)=>({...data,id:id,show:true}))
  // }

  const handleLogin = (id) => {
    //  setAnchorEls(Array(tabFilterData.length).fill(null));
    setMenuOpen(false);
    setIsLoginModalOpen(true);
    setAgentId(id);
  };
  const RightContent = () => {
    return (
      <div className="flex justify-end">
        <div className="mr-6">
          <SearchInput value="" />
        </div>
        <div>
          <button className="btn-md" onClick={() => setShowManageModal(true)}>
            Create New Agent
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="main_content flex-[1] bg-[#F5F5F5] w-[100%] min-h-screen">
      <PrimaryHeader
        sort={sort}
        setSort={setSort}
        title={"Agent Accounts"}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        btnTitle={"Create New Agent"}
        tabData={tabData}
        setShowModal={setShowManageModal}
        searchText={searchText}
        setSearchText={setSearchText}
        onChange={onChange}
        pagePermission={pagePermission}
      />
      <div className="p-[50px_25px]">
        {!loading ? (
          <div className="flex flex-wrap gap-[35px_20px]">
            {items.length == 0 && (
              <h2 class="font-[700] text-2xl text-center w-full">No Results</h2>
            )}
            {[...tabFilterData].map((item, index) => (
              <AgentGridItem
                anchorEl={anchorEls[index]}
                menuOpen={menuOpen && anchorEls[index] !== null}
                handleOpenMenu={handleOpenMenu}
                handleCloseMenu={handleCloseMenu}
                handleLogin={handleLogin}
                index={index}
                key={index}
                data={item}
                onFeatureClick={onFeatureClick}
                onDeleteClick={onDeleteClick}
                pagePermission={pagePermission}
              />
            ))}
          </div>
        ) : (
          <LoaderComp />
        )}
      </div>
      {showManageModal ? (
        <CreateModal
          getAgents={getAgents}
          active={showManageModal}
          setActive={setShowManageModal}
          setItems={setItems}
        />
      ) : null}
      {showUpdateModal ? (
        <EditModal active={showUpdateModal} setActive={setShowUpdateModal} />
      ) : null}
      {featureModal.show ? (
        <ConfirmationPopup
          type={"feature"}
          setActiveData={setFeatureModal}
          activeData={featureModal}
          onConfirm={confirmFeatured}
        />
      ) : null}
      {inactiveModal.show ? (
        <ConfirmationPopup
          type={"inactive"}
          setActiveData={setInactiveModal}
          activeData={inactiveModal}
          onConfirm={confirmInactive}
        />
      ) : null}
      {deleteModal.show ? (
        <AgentConfirmationPopup
          onClose={setDeleteModal}
          type={"delete"}
          setActiveData={setDeleteModal}
          activeData={deleteModal}
          onConfirm={confirmDelete}
        />
      ) : null}
      {isLoginModalOpen && <SecurityPinNumber
        open={isLoginModalOpen}
        onClose={() => setIsLoginModalOpen(false)}
        id={agentId}
        type={'agent'}
        onConfirm={(pin) => {
          // Validate pin or perform login
          //  navigate(`/login-as-agent/${data.id}`);
          setIsLoginModalOpen(false);
        }}
      />}
    </div>
  );
}

const CreateModal = ({ active, setActive, setItems, getAgents }) => {
  const errData = {
    name: false,
    email: false,
    password: false,
    confirmPassword: false,
    passwordMatch: false,
    icon: false,
    uenNumber: false,
    faxNumber: false,
    countryCode: false,
    phoneNumber: false,
    featured: false,
    id: false,
    approvalTime: false,
    ltv: false,
    addressLine1: false,
    addressLine2: false,
    country: false,
    postalCode: false,
    contacts: [
      {
        name: false,
        email: false,
        isPrimary: false,
        emailUpdate: false,
        smsUpdate: false,
        designation: false,
        countryCode: false,
        phoneNumber: false,
      },
    ],
  };
  const [createData, setCreateData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    passwordMatch: false,
    icon: "",
    uenNumber: null,
    faxNumber: null,
    countryCode: "+65",
    phoneNumber: null,
    featured: 0,
    approvalTime: 1,
    ltv: 1,
    addressLine1: "",
    addressLine2: "",
    country: "SG",
    postalCode: null,
    floor_approvalTime: "",
    floor_ltv: "",
    contacts: [
      {
        name: "",
        email: "",
        isPrimary: 1,
        emailUpdate: 0,
        smsUpdate: 0,
        designation: "",
        countryCode: "+65",
        phoneNumber: null,
      },
    ],
  });
  const [image, setImage] = useState(null);
  const [showCrop, setShowCrop] = useState(false);
  const [croppedImage, setCroppedImage] = useState();
  const settings = useSelector((state) => state.settings);
  const [viewMode, setViewMode] = useState(false);
  const [errors, setErrors] = useState(errData);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("in-house");

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setShowCrop(true);
      setImage(URL.createObjectURL(event.target.files[0]));
    }
  };

  const onSubmit = async (e) => {
    try {
      setErrors(errData);
      e.preventDefault();
      if (createData.password !== createData.confirmPassword) {
        setErrors((data) => ({
          ...data,
          confirmPassword: "Password does not match",
        }));
        return false;
      } else if (!croppedImage) {
        setErrors((data) => ({ ...data, icon: "Please upload the logo" }));
        return false;
      }
      // setLoading(true);
      let blobFile = await dataURItoBlob(croppedImage);
      let formData = new FormData();
      formData.append("file", blobFile, "crop-icon.jpg");
      formData.append("module", "agent");

      let fileRes = await axios.post("/admin/upload/image", formData);
      let res = await axios.post("/admin/agent/create", {
        ...createData,
        icon: fileRes.data.data,
      });
      await getAgents();
      setCreateData((data) => ({
        ...data,
        icon: fileRes.data.data,
        id: res.data.data.id,
      }));
      setViewMode(true);
      setLoading(false);
    } catch (error) {
      Object.keys(error.response.data.errors).forEach(function (key) {
        toast.error(
          error.response.data.errors[key] !== undefined
            ? error.response.data.errors[key]
            : "Error occured profile not updated..!"
        );
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    //console.log("createData", createData);
  }, [createData]);

  // const onCrate
  return (
    <>
      <OffCanvasModal
        title={"Create new agent"}
        active={active}
        setActive={setActive}
      >
        <form className="w-full" onSubmit={onSubmit}>
          <div className="grid grid-cols-2 gap-x-3 gap-y-3 md:gap-y-3">
            <div className="col-span-2">
              <label>Agent Email</label>
              <Input
                type="email"
                required={true}
                viewMode={viewMode}
                value={createData.email}
                placeholder={"Enter Email address"}
                setValue={(value) =>
                  setCreateData((data) => ({ ...data, email: value }))
                }
              />
            </div>
            <div className="col-span-1">
              <label>Password</label>
              <Input
                type="password"
                value={createData.password}
                required={true}
                viewMode={viewMode}
                placeholder={"Enter Password"}
                setValue={(value) =>
                  setCreateData((data) => ({ ...data, password: value }))
                }
              />
            </div>
            <div className="col-span-1">
              {viewMode ? null : (
                <>
                  <label>Confirm Password</label>
                  <Input
                    type="password"
                    value={createData.confirmPassword}
                    required={true}
                    viewMode={viewMode}
                    placeholder={"Confirm Password"}
                    setValue={(value) =>
                      setCreateData((data) => ({
                        ...data,
                        confirmPassword: value,
                      }))
                    }
                    error={errors?.confirmPassword}
                  />
                </>
              )}
            </div>
          </div>
          <div className="mt-5">
            <p className="text-sm tracking-tight font-semibold mb-6 md:mb-0">
              Agent Details
            </p>
            <div className="grid grid-cols-3 mt-2 gap-x-3 gap-y-3 md:gap-y-3">
              <div className="col-span-3 md:col-span-1">
                <label>Agent&apos;s Logo</label>
                {viewMode ? (
                  <img
                    src={`${IMAGE_BASE_URL}/${createData.icon}`}
                    className="h-5 w-5 rounded-md"
                  />
                ) : (
                  <ImageInput
                    viewMode={viewMode}
                    image={
                      createData.icon && createData.icon !== ""
                        ? `${IMAGE_BASE_URL}/${createData.icon}`
                        : croppedImage
                    }
                    setImage={onImageChange}
                    error={errors ? errors["icon"] : null}
                  />
                )}
              </div>
              {/* <div className="col-span-3 md:col-span-1">
                <label>Approval Time</label>
                {viewMode ? (
                  <p className="text-sm text-black">
                    {getNameFromSettings(
                      settings,
                      SETTINGS_APPROVAL_TIME_LIST,
                      createData.approvalTime
                    )}
                  </p>
                ) : (
                  <CustomSelect
                    required={true}
                    disabled={viewMode}
                    placeholder={"Select Approval Time"}
                    options={settings[SETTINGS_APPROVAL_TIME_LIST]}
                    value={createData.approvalTime}
                    setValue={(value) =>
                      setCreateData((data) => ({
                        ...data,
                        approvalTime: value,
                      }))
                    }
                    error={errors ? errors["approvalTime"] : null}
                  />
                )}
              </div>
              <div className="col-span-3 md:col-span-1">
                <label>Loan To Value</label>
                {viewMode ? (
                  <p className="text-sm text-black">
                    {getNameFromSettings(
                      settings,
                      SETTINGS_LTV_LIST,
                      createData.ltv
                    )}
                  </p>
                ) : (
                  <CustomSelect
                    required={true}
                    disabled={viewMode}
                    placeholder={"Select Loan to Value"}
                    options={settings[SETTINGS_LTV_LIST]}
                    value={createData.ltv}
                    setValue={(value) =>
                      setCreateData((data) => ({ ...data, ltv: value }))
                    }
                    error={errors ? errors["ltv"] : null}
                  />
                )}
              </div> */}
              <div className="col-span-2 ">
                <label>Agent Company Name</label>
                <Input
                  value={createData.name}
                  required={true}
                  viewMode={viewMode}
                  placeholder={"Agent Company Name"}
                  setValue={(value) =>
                    setCreateData((data) => ({ ...data, name: value }))
                  }
                />
              </div>
              <div className="col-span-1">
                <label>UEN Number</label>
                <Input
                  type="text"
                  value={createData.uenNumber}
                  required={true}
                  viewMode={viewMode}
                  placeholder={"UEN Number"}
                  setValue={(value) =>
                    setCreateData((data) => ({ ...data, uenNumber: value }))
                  }
                />
              </div>
              <div className="col-span-3 md:col-span-2 gap-x-2">
                <div className="grid grid-cols-4 justify-between gap-x-3">
                  <div>
                    <label>Country Code</label>
                    {viewMode ? (
                      <p className="text-sm text-black">
                        {createData.countryCode}
                      </p>
                    ) : (
                      <CustomSelect
                        customLabel={"dial_code"}
                        customValue={"dial_code"}
                        required={true}
                        disabled={viewMode}
                        placeholder={"Select Country Code"}
                        options={CountryCode}
                        value={createData.countryCode}
                        setValue={(value) =>
                          setCreateData((data) => ({
                            ...data,
                            countryCode: value,
                          }))
                        }
                      />
                    )}
                  </div>
                  <div className="col-span-3">
                    <label>Contact Number</label>
                    <Input
                      type="text"
                      number={true}
                      value={createData.phoneNumber}
                      required={true}
                      viewMode={viewMode}
                      placeholder={"Contact Number"}
                      setValue={(value) =>
                        setCreateData((data) => ({
                          ...data,
                          phoneNumber: value,
                        }))
                      }
                      maxLength={8}
                    />
                  </div>
                </div>
              </div>
              <div className="col-span-3 md:col-span-1">
                <label>Fax Number</label>
                <Input
                  type="text"
                  number={true}
                  value={createData.faxNumber}
                  viewMode={viewMode}
                  placeholder={"Fax Number"}
                  setValue={(value) =>
                    setCreateData((data) => ({ ...data, faxNumber: value }))
                  }
                />
              </div>
            </div>
            <div className={`${viewMode ? "mt-3" : ""}`}>
              <div>
                <label>{viewMode ? "Address Line 1" : "Address"}</label>
                <Input
                  type="text"
                  value={createData.addressLine1}
                  required={true}
                  viewMode={viewMode}
                  placeholder={"Address 1 ( Floor, Unit No., Street Name)"}
                  setValue={(value) =>
                    setCreateData((data) => ({ ...data, addressLine1: value }))
                  }
                />
              </div>
            </div>
            <div className={`${viewMode ? "mt-3" : ""}`}>
              <div>
                {viewMode ? <label>Address Line 2</label> : null}
                <Input
                  type="text"
                  value={createData.addressLine2}
                  required={true}
                  viewMode={viewMode}
                  placeholder={"Address 2 (Building name, other info)"}
                  setValue={(value) =>
                    setCreateData((data) => ({ ...data, addressLine2: value }))
                  }
                />
              </div>
            </div>
            <div
              className={`grid grid-cols-2 gap-x-3 ${viewMode ? "mt-3" : ""}`}
            >
              <div>
                {viewMode ? <label>Postal Code</label> : null}
                <Input
                  type="text"
                  value={createData.postalCode}
                  required={true}
                  viewMode={viewMode}
                  placeholder={"Postal Code"}
                  setValue={(value) =>
                    setCreateData((data) => ({ ...data, postalCode: value }))
                  }
                />
              </div>
              <div>
                {viewMode ? (
                  <p className="text-sm text-black">
                    {getCountryFromSettings(createData.country)}
                  </p>
                ) : (
                  <CustomSelect
                    required={true}
                    disabled={viewMode}
                    placeholder={"Select Country"}
                    customValue={"code"}
                    options={CountryCode}
                    value={createData.country}
                    setValue={(value) =>
                      setCreateData((data) => ({ ...data, country: value }))
                    }
                    error={errors ? errors["country"] : null}
                  />
                )}
              </div>
            </div>
            <div className="mt-5">
              <p className="text-sm tracking-tight font-semibold">Ratings</p>
              <InfoTab activeTab={activeTab} setActiveTab={setActiveTab} />
              {activeTab === "in-house" ? (
                <div className="columns-[200px] gap-[15px] mt-[20px]">
                  <div className="md:inline-block">
                    <label>Approval Time</label>
                    {viewMode ? (
                      <p className="text-sm text-black">
                        {createData.approvaltimeinfo?.name}
                      </p>
                    ) : (
                      <CustomSelect
                        required={true}
                        disabled={viewMode}
                        placeholder={"Select Approval Time"}
                        options={settings[SETTINGS_APPROVAL_TIME_LIST]}
                        value={createData.approvalTime}
                        setValue={(value) =>
                          setCreateData((data) => ({
                            ...data,
                            approvalTime: value,
                          }))
                        }
                        error={errors ? errors["approvalTime"] : null}
                      />
                    )}
                  </div>
                  <div className="">
                    <label>Loan To Value</label>
                    {viewMode ? (
                      <p className="text-sm text-black">
                        {createData.ltvinfo?.name}
                      </p>
                    ) : (
                      <CustomSelect
                        required={true}
                        disabled={viewMode}
                        placeholder={"Select Loan to Value"}
                        options={settings[SETTINGS_LTV_LIST]}
                        value={createData.ltv}
                        setValue={(value) =>
                          setCreateData((data) => ({ ...data, ltv: value }))
                        }
                        error={errors ? errors["ltv"] : null}
                      />
                    )}
                  </div>
                </div>
              ) : (
                <div className="columns-[200px] gap-[15px] mt-[20px]">
                  <div className="md:inline-block">
                    <label>Approval Time</label>
                    {viewMode ? (
                      <p className="text-sm text-black">
                        {createData.floor_approvaltimeinfo?.name !== undefined
                          ? createData.floor_approvaltimeinfo?.name
                          : "--"}
                      </p>
                    ) : (
                      <CustomSelect
                        required={true}
                        disabled={viewMode}
                        placeholder={"Select Approval Time"}
                        options={settings[SETTINGS_APPROVAL_TIME_LIST]}
                        value={createData.floor_approvalTime}
                        setValue={(value) =>
                          setCreateData((data) => ({
                            ...data,
                            floor_approvalTime: value,
                          }))
                        }
                        error={errors ? errors["floor_approvalTime"] : null}
                      />
                    )}
                  </div>
                  <div className="">
                    <label>Loan To Value</label>
                    {viewMode ? (
                      <p className="text-sm text-black">
                        {createData.floor_ltvinfo?.name !== undefined
                          ? createData.floor_ltvinfo?.name
                          : "--"}
                      </p>
                    ) : (
                      <CustomSelect
                        required={true}
                        disabled={viewMode}
                        placeholder={"Select Loan to Value"}
                        options={settings[SETTINGS_LTV_LIST]}
                        value={createData.floor_ltv}
                        setValue={(value) =>
                          setCreateData((data) => ({
                            ...data,
                            floor_ltv: value,
                          }))
                        }
                        error={errors ? errors["floor_ltv"] : null}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className="mt-5">
              <p className="text-sm tracking-tight font-semibold mb-6 md:mb-6">
                Point of contact
              </p>
              <div className="grid grid-cols-2 gap-x-3 gap-y-3 md:gap-y-3">
                <div className="col-span-1 md:col-span-1">
                  <label>Name</label>
                  <Input
                    type="text"
                    value={createData.contacts[0].name}
                    required={true}
                    viewMode={viewMode}
                    placeholder={"Name"}
                    setValue={(value) =>
                      setCreateData((data) => ({
                        ...data,
                        contacts: [
                          (data.contacts[0] = {
                            ...data.contacts[0],
                            name: value,
                          }),
                        ],
                      }))
                    }
                  />
                </div>
                <div className="col-span-1 md:col-span-1">
                  <label>Designation</label>
                  <Input
                    type="text"
                    value={createData.contacts[0].designation}
                    required={true}
                    viewMode={viewMode}
                    placeholder={"Designation"}
                    setValue={(value) =>
                      setCreateData((data) => ({
                        ...data,
                        contacts: [
                          (data.contacts[0] = {
                            ...data.contacts[0],
                            designation: value,
                          }),
                        ],
                      }))
                    }
                  />
                </div>
                <div className="col-span-2 md:col-span-1 gap-x-2">
                  <div className="grid grid-cols-3 justify-between gap-x-3">
                    <div>
                      <label>Country Code</label>
                      {viewMode ? (
                        <p className="text-sm text-black">
                          {createData.contacts[0].countryCode}
                        </p>
                      ) : (
                        <CustomSelect
                          customLabel={"dial_code"}
                          customValue={"dial_code"}
                          required={true}
                          disabled={viewMode}
                          placeholder={"Select Country"}
                          options={CountryCode}
                          value={createData.contacts[0].countryCode}
                          setValue={(value) =>
                            setCreateData((data) => ({
                              ...data,
                              contacts: [
                                (data.contacts[0] = {
                                  ...data.contacts[0],
                                  countryCode: value,
                                }),
                              ],
                            }))
                          }
                          error={
                            errors &&
                              errors["contacts"] &&
                              errors["contacts"][0]
                              ? errors["contacts"][0]["countryCode"]
                              : null
                          }
                        />
                      )}
                    </div>
                    <div className="col-span-2">
                      <label>Contact Number</label>
                      <Input
                        type="text"
                        value={createData.contacts[0].phoneNumber}
                        required={true}
                        viewMode={viewMode}
                        placeholder={"Contact Number"}
                        setValue={(value) =>
                          setCreateData((data) => ({
                            ...data,
                            contacts: [
                              (data.contacts[0] = {
                                ...data.contacts[0],
                                phoneNumber: value,
                              }),
                            ],
                          }))
                        }
                        error={
                          errors && errors["contacts"] && errors["contacts"][0]
                            ? errors["contacts"][0]["contactNumber"]
                            : null
                        }
                        maxLength={8}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-span-3 md:col-span-1">
                  <label>Email address</label>
                  <Input
                    type="email"
                    value={createData.contacts[0].email}
                    required={true}
                    viewMode={viewMode}
                    placeholder={"Enter Email"}
                    setValue={(value) =>
                      setCreateData((data) => ({
                        ...data,
                        contacts: [
                          (data.contacts[0] = {
                            ...data.contacts[0],
                            email: value,
                          }),
                        ],
                      }))
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="flex mt-6">
            {viewMode ? (
              <Link to={`/accounts/agents/${createData.id}`} className="btn-md">
                View
              </Link>
            ) : (
              <button
                className="btn-md capitalize"
                type="submit"
                disabled={loading}
              >
                Create Agent
              </button>
            )}
            <button
              className="ml-4 btn-md-disabled"
              onClick={() => setActive(false)}
            >
              {viewMode ? "Close" : "Cancel"}
            </button>
          </div>
        </form>
      </OffCanvasModal>
      {showCrop ? (
        <CropPopup
          image={image}
          setActive={setShowCrop}
          setImage={setCroppedImage}
        />
      ) : null}

    </>
  );
};

const EditModal = ({ active, setActive }) => {
  const [image, setImage] = useState(null);
  const [showCrop, setShowCrop] = useState(false);

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setShowCrop(true);
      setImage(URL.createObjectURL(event.target.files[0]));
    }
  };

  const [updateData, setUpdateData] = useState(active);
  return (
    <>
      <OffCanvasModal
        title={"Update loan provider"}
        active={active}
        setActive={setActive}
      >
        <div>
          <div className="grid grid-cols-3 gap-x-3 gap-y-4">
            <div className="col-span-1">
              <label>Loan Provider Logo</label>
              <ImageInput image={image} setImage={onImageChange} />
            </div>
            <div className="col-span-2">
              <label>Loan Provider Name</label>
              <input
                type="text"
                className="text-input"
                value={updateData.name}
                onChange={(e) =>
                  setUpdateData((data) => ({ ...data, name: e.target.value }))
                }
              />
            </div>
            <div>
              <label>Type</label>
              <select
                value={updateData.type}
                onChange={(e) =>
                  setUpdateData((data) => ({ ...data, type: e.target.value }))
                }
              >
                <option value={""} disabled>
                  Select Type
                </option>
                <option value={"bank"}>Bank</option>
                <option value={"financialInstitution"}>
                  Financial Institution
                </option>
                <option value={"inHouse"}>In-House</option>
              </select>
            </div>
            <div>
              <label>Approval Time</label>
              <select
                defaultValue={""}
                value={updateData.approvalTime}
                onChange={(e) =>
                  setUpdateData((data) => ({
                    ...data,
                    approvalTime: e.target.value,
                  }))
                }
              >
                <option value={""} disabled>
                  Select Approval Time
                </option>
                <option value={"veryFast"}>Very Fast</option>
                <option value={"fast"}>Fast</option>
                <option value={"normal"}>Normal</option>
              </select>
            </div>
            <div>
              <label>LTV</label>
              <select
                defaultValue={""}
                value={updateData.ltv}
                onChange={(e) =>
                  setUpdateData((data) => ({ ...data, ltv: e.target.value }))
                }
              >
                <option value={""} disabled>
                  Select LTV
                </option>
                <option value={"veryHigh"}>Very High</option>
                <option value={"high"}>High</option>
                <option value={"normal"}>Normal</option>
              </select>
            </div>
            <div>
              <label>Listing Type</label>
              <button
                className={`px-3 mt-1 py-2 rounded-[5px] text-sm font-medium ${updateData.featured
                  ? "bg-blue-200 text-blue-700"
                  : "bg-gray-200 text-gray-600"
                  }`}
                onClick={() =>
                  setUpdateData((data) => ({
                    ...data,
                    featured: !data.featured,
                  }))
                }
              >
                Featured
              </button>
            </div>
          </div>
          <div className="flex mt-10">
            <button className="btn-md">Update loan provider</button>
            <button
              className="ml-4 btn-md-disabled"
              onClick={() => setActive(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </OffCanvasModal>
      {showCrop ? <CropPopup image={image} setActive={setShowCrop} /> : null}
    </>
  );
};
